import type {
  RadioGroupProps as ChakraRadioGroupProps,
  StackProps
} from '@chakra-ui/react'
import {
  RadioGroup as ChakraRadioGroup,
  forwardRef,
  Stack
} from '@chakra-ui/react'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'
import React from 'react'

export interface RadioGroupProps extends ChakraRadioGroupProps {
  children: React.ReactNode
  name: string
  stackProps?: StackProps
  onChange?: (value: string) => void
  onChangeValueTransform?: (value: string) => any
  valueTransform?: (value: any) => string | undefined
}

export const RadioGroup = forwardRef(
  ({ children, name, stackProps, onChangeValueTransform, valueTransform, sx, ...rest }: RadioGroupProps, _) => {
    const { control, trigger } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <ChakraRadioGroup
            value={valueTransform ? valueTransform(value) : value?.toString() ?? ''}
            onChange={(val) => {
              onChange(onChangeValueTransform ? onChangeValueTransform(val) : val)
            }}
            {...rest}
          >
            <Stack
              direction={{
                base: 'column',
                lg: 'row',
              }}
              spacing={{
                base: 2,
                lg: 16,
              }}
              {...stackProps}
            >
              {children}
            </Stack>
          </ChakraRadioGroup>
        )}
      />
    )
  },
)
